module.exports = __webpack_public_path__ + "media/images/JemTheMovie/FB_Jem_470x246-9a2a4101cdf01c81f97457f8dbc1a6b2.png";